export const selectAllIVAs = ({ IVAsSlice: oState }) => oState?.aIVAs;
